import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from '../../components';
import services from '../../services/services';
import { exposeComponentToGlobalScope } from '../../utils/utilsGlobal';
import styles from './SchedulerReasonModal.scss';
import uiStyles from '../../styles/ui.scss';


const mapStateToProps = state => {
  return {
    currentCompany: state.currentCompany,
    workHoursSchedulerReasons: state.workHoursSchedulerReasons,
  };
};

@connect(mapStateToProps)
export class SchedulerReasonModal extends Component {

  state = {
    reasonId: null,
    comment: '',
    isSwitchOffUnavailable: false,
  };

  firstRadioButton = React.createRef();

  componentDidMount(){
    this.setDefaultReasonId();
    exposeComponentToGlobalScope(this);
  }

  componentDidUpdate(prevProps){
    if (!prevProps.workHoursSchedulerReasons.length) {
      this.setDefaultReasonId();
    }
  }

  setDefaultReasonId = () => {
    const { workHoursSchedulerReasons } = this.props;
    const { reasonId } = this.state;
    if (workHoursSchedulerReasons.length && !reasonId) {
      this.setState({ reasonId: workHoursSchedulerReasons[0].id }, () => {
        this.firstRadioButton.current?.focus?.();
      });
    }
  };

  onReasonChange = (selectedReason) => {
    this.setState({ reasonId: selectedReason.id });
  };

  onCommentChange = (e) => {
    this.setState({ comment: e.target.value });
  };

  onSubmit = (e) => {
    const { onSuccess } = this.props;
    const { reasonId, comment } = this.state;

    e.preventDefault();

    services.workHoursScheduler
      .switchManually({ isWorking: false, reasonId, comment })
      .then(onSuccess)
      .catch(e => {
        if (e.errorType === 'NOT_AVAILABLE') {
          e.overrideErrorNotification({ alert: false });
          this.setState({ isSwitchOffUnavailable: true });
        }
      });
  };

  render(){
    const { className, workHoursSchedulerReasons, onClose } = this.props;
    const { reasonId, comment, isSwitchOffUnavailable } = this.state;

    return (
      <Modal className={className}
        verticallyCentered={true}
        title="Причина перерыва"
        onClose={onClose}>

        <form onSubmit={this.onSubmit}>
          <ul className={styles.list}>
            {workHoursSchedulerReasons.map((reason, index) => (
              <li className={styles.listItem} key={reason.id}>
                <label className={styles.listLabel}>
                  <input className={styles.listCheckbox}
                    type="radio"
                    ref={index === 0 && this.firstRadioButton}
                    value={reason.id}
                    checked={reasonId === reason.id}
                    onChange={() => this.onReasonChange(reason)}
                    name="take-break-reason"/>
                  {reason.title}
                </label>
              </li>
            ))}
          </ul>

          <input className={styles.comment}
            type="text"
            value={comment}
            placeholder="Необязательный комментарий"
            onChange={this.onCommentChange}/>

          <div className={styles.buttons}>
            <button className={uiStyles.buttonPrimary} type="submit">
              Уйти на перерыв
            </button>
          </div>
        </form>

        {isSwitchOffUnavailable && (
          <div className={styles.switchOffUnavailable}>
            <h2 className={styles.switchOffUnavailableHeader}>
              Невозможно уйти на перерыв
            </h2>
            <div className={styles.switchOffUnavailableText}>
              Сейчас нельзя уйти на перерыв, так как останется мало менеджеров. Попробуйте позднее
            </div>
            <button
              className={uiStyles.buttonSecondary}
              onClick={() => this.setState({ isSwitchOffUnavailable: false })}>
              Закрыть
            </button>
          </div>
        )}
      </Modal>
    );
  }
}
